import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { AppService } from '../../services/prod/app.service'
import { I18nService, LgType } from '../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-comments',
  templateUrl: './bmcore-comments.component.html',
  styleUrls: ['./bmcore-comments.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreCommentsComponent implements OnInit {
  lg: LgType
  beatmakerName: string

  constructor(
    private i18nService: I18nService,
    private appService: AppService
  ) {}

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
    this.getBeatmakerData()
  }

  getBeatmakerData() {
    this.appService.beatMakerDataSubject.subscribe(res => {
      if (res) {
        this.beatmakerName = res.beatmakerName
      }
    })
  }
}
